// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.poppins-normal-9 {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 400 !important;
    font-size: 9px !important;
    line-height: 14px !important;
}

.poppins-normal-10 {
    font-family: 'Poppins', sans-serif !important;
    font-size: 11px !important;
    font-weight: 400 !important;
    line-height: 15px !important;
    letter-spacing: 0 !important;
}

.poppins-normal-14 {
    font-family: 'Poppins', sans-serif !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 21px !important;
}

.poppins-normal-16, div.poppins-normal-16 > p {
    font-family: 'Poppins', sans-serif !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px !important;
}

.poppins-medium-36, div.poppins-medium-36 > p {
    font-family: 'Poppins', sans-serif !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 36px !important;
    line-height: 54px !important;
}

.poppins-semi-bold-14, .poppins-semi-bold-14 > p {
    font-family: Poppins, sans-serif !important;
    font-size: 14px !important;
    font-weight: 600 !important;
}

.poppins-semi-bold-16, div.poppins-semi-bold-16 > p {
    font-family: Poppins, sans-serif !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    text-align: center !important;
}

.inter-normal-24 {
    font-family: 'Inter', sans-serif !important;
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 24px !important;
    line-height: 29px !important;
}

.inter-normal-48 {
    font-family: 'Inter', sans-serif !important;
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 48px !important;
    line-height: normal !important;
}

.normal-400 {
    font-weight: 400 !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/typography.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;IAC7C,2BAA2B;IAC3B,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,6CAA6C;IAC7C,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,6CAA6C;IAC7C,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,6CAA6C;IAC7C,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,6CAA6C;IAC7C,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,2CAA2C;IAC3C,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,2CAA2C;IAC3C,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".poppins-normal-9 {\n    font-family: 'Poppins', sans-serif !important;\n    font-weight: 400 !important;\n    font-size: 9px !important;\n    line-height: 14px !important;\n}\n\n.poppins-normal-10 {\n    font-family: 'Poppins', sans-serif !important;\n    font-size: 11px !important;\n    font-weight: 400 !important;\n    line-height: 15px !important;\n    letter-spacing: 0 !important;\n}\n\n.poppins-normal-14 {\n    font-family: 'Poppins', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n    font-size: 14px !important;\n    line-height: 21px !important;\n}\n\n.poppins-normal-16, div.poppins-normal-16 > p {\n    font-family: 'Poppins', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n}\n\n.poppins-medium-36, div.poppins-medium-36 > p {\n    font-family: 'Poppins', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 500 !important;\n    font-size: 36px !important;\n    line-height: 54px !important;\n}\n\n.poppins-semi-bold-14, .poppins-semi-bold-14 > p {\n    font-family: Poppins, sans-serif !important;\n    font-size: 14px !important;\n    font-weight: 600 !important;\n}\n\n.poppins-semi-bold-16, div.poppins-semi-bold-16 > p {\n    font-family: Poppins, sans-serif !important;\n    font-weight: 600 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    text-align: center !important;\n}\n\n.inter-normal-24 {\n    font-family: 'Inter', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 600 !important;\n    font-size: 24px !important;\n    line-height: 29px !important;\n}\n\n.inter-normal-48 {\n    font-family: 'Inter', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 600 !important;\n    font-size: 48px !important;\n    line-height: normal !important;\n}\n\n.normal-400 {\n    font-weight: 400 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
